import {Component, Input} from '@angular/core';
import {MarketingDetailColumnGroupInterface} from '../../../models/marketing-detail.model';
import {CoverageLevelModel} from '../../../models/plans.model';

@Component({
  selector: 'app-plan-summary',
  templateUrl: './plan-summary.component.html',
  styleUrls: ['./plan-summary.component.scss'],
  standalone: false
})

export class PlanSummaryComponent {
  @Input() public planSummary?: MarketingDetailColumnGroupInterface[] = [];
  @Input() public coverageLevel?: CoverageLevelModel;
}
